import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {exportBookings} from "../../Requests/BookingListRequests";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import SelectInput from "../../../../Components/Inputs/SelectInput";
import ActionButton from "../../../../Components/Buttons/ActionButton";
import DateRangeInputRow from "../../../../Components/Inputs/DateRangeInputRow";
import StandardModal from "../../../../Components/Modals/StandardModal";

/**
 * Export modal interface for selecting export options for the whole
 * visitors module, including both the bookings & logs pages
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ExportModal = (props) => {
    let dispatch = useDispatch();

    let [dateRangeStart, setDateRangeStart] = React.useState(false);
    let [dateRangeEnd, setDateRangeEnd] = React.useState(false);
    let [filetype, setFiletype] = React.useState('xlsx');
    let [sort, setSort] = React.useState('asc');
    let [isOpen, setIsOpen] = React.useState(false);

    const stateDateRangeStart = useSelector(state => state.module.BOOKINGS.filters.dateRangeStart);
    const stateDateRangeEnd = useSelector(state => state.module.BOOKINGS.filters.dateRangeEnd);
    
    useEffect(() => {
        setDateRangeStart(stateDateRangeStart);
        setDateRangeEnd(stateDateRangeEnd);
    }, [stateDateRangeStart, stateDateRangeEnd]);

    useEffect(() => {
        setIsOpen(props.open);
    }, [props.open]);

    const handleDateRangeChange = (startDate, endDate) => {
        setDateRangeStart(startDate);
        setDateRangeEnd(endDate);
    }

    const handleClose = () => {
        props.onClose();
    }

    const handleExport = () => {
        dispatch(exportBookings(
            props.scope,
            props.view,
            dateRangeStart,
            dateRangeEnd,
            filetype,
            sort
        ));
    }

    return (
        <StandardModal
            title="Export Bookings"
            open={isOpen}
            onClose={handleClose}
        >
            <p className="margin-bottom-2">
                Click below to generate a data export using the current filter settings.
            </p>

            <form>
                <FormRow
                    label="Date Range"
                    className="large-input"
                    errorMessage={(!dateRangeStart || !dateRangeEnd) ?
                        'Please set a date range for the export' : null
                    }
                    tooltip=""
                >
                    <DateRangeInputRow
                        onChange={handleDateRangeChange}
                        startDate={dateRangeStart}
                        endDate={dateRangeEnd}
                    />
                </FormRow>

                <FormRow
                    label="Filetype"
                    tooltip=""
                >
                    <SelectInput
                        name="filetype"
                        value={filetype}
                        options={[
                            {value: 'xlsx', label: 'XLSX (Microsoft Excel)'},
                            {value: 'csv', label: 'CSV'},
                        ]}
                        onChange={(e) => setFiletype(e.target.value)}
                    />
                </FormRow>

                <FormRow
                    label="Sort"
                    tooltip=""
                >
                    <SelectInput
                        name="sort"
                        value={sort}
                        options={[
                            {value: 'asc', label: 'By Date, ascending'},
                            {value: 'desc', label: 'By Date, descending'},
                        ]}
                        onChange={(e) => setSort(e.target.value)}
                    />
                </FormRow>


                <div className="grid-x margin-top-2">
                    <div className="cell auto text-right">
                        <div className="button-group align-right text-right margin-bottom-0">
                            <ActionButton
                                onClick={handleExport}
                                isDisabled={!(dateRangeStart && dateRangeEnd)}
                                title="Export"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </StandardModal>
    )
}

ExportModal.defaultProps = {
    open: false,
}

export default ExportModal;
